import { useEffect } from 'react';
import { useNavigate} from "react-router-dom";
import Cookies from "js-cookie";
const ForceLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    
    navigate("/admin-login", { replace: true });
    // Clear admin localStorage token on component mount
    localStorage.removeItem("access_token_admin");
    localStorage.removeItem("login_Details");
       Cookies.remove("access_token_admin");
          Cookies.remove("refresh_token");
    
  }, []);

  return (
    <div>
      {/* <h1>Logging out...</h1> */}
    </div>
  );
};

export default ForceLogout;
